<template>
  <span :class="classes" class="">
    <slot></slot>
  </span>
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { Variant, Size } from "./types";

export interface BadgeProps {
  variant?: Variant;
  size?: Size;
}

const variants = {
  info: "tw-bg-info-100",
  warning: "tw-bg-warning-200",
  danger: "tw-bg-danger-100",
};

const sizes = {
  sm: "tw-px-1",
  base: "tw-px-2 tw-py-1",
};

const props = withDefaults(defineProps<BadgeProps>(), {
  variant: "info",
  size: "base",
});

const classes = computed(() => {
  return [
    "tw-inline-flex tw-items-center tw-rounded",
    variants[props.variant],
    sizes[props.size],
  ];
});
</script>
